import { AccommodationScreen } from './accommodation-screen'

export const AccommodationScreenContainer = () => {
  return <AccommodationScreen />
}
